<template>
    <div class="white-card">
      <div class="organizers card">
        <p class="title">{{ $t("organization.title1") }}</p>
        <p class="line"></p>
        <div class="ar_article_box">
          <div class="ar_article">
              <p style="text-indent: 2em; line-height: 2em;"><span style="font-size: 18px;"></span>
                <span style="font-size: 18px;">
                  {{ $t("organization.title1description1") }}
                </span>
              </p>
            <p style="text-indent: 2em; line-height: 2em;"><span style="font-size: 18px;"></span>
              <span style="font-size: 18px;">
                  {{ $t("organization.title1description2") }}
                </span>
            </p>
            <p style="text-indent: 2em; line-height: 2em;"><span style="font-size: 18px;"></span>
              <span style="font-size: 18px;">
                  {{ $t("organization.title1description3") }}
                </span>
            </p>
            <p style="text-indent: 2em; line-height: 2em;"><span style="font-size: 18px;"></span>
              <span style="font-size: 18px;">
                  {{ $t("organization.title1description4") }}
                </span>
            </p>
            <p style="text-indent: 2em; line-height: 2em;"><span style="font-size: 18px;"></span>
              <span style="font-size: 18px;">
                  {{ $t("organization.title1description5") }}
                </span>
            </p>
            <p style="text-indent: 2em; line-height: 2em;"><span style="font-size: 18px;"></span>
              <span style="font-size: 18px;">
                  {{ $t("organization.title1description6") }}
                </span>
            </p>
            <p style="text-indent: 2em; line-height: 2em;"><span style="font-size: 18px;"></span>
              <span style="font-size: 18px;">
                  {{ $t("organization.title1description7") }}
                </span>
            </p>
            <p style="text-indent: 2em; line-height: 2em;"><span style="font-size: 18px;"></span>
              <span style="font-size: 18px;">
                  {{ $t("organization.title1description8") }}
                </span>
            </p>
            <p style="text-indent: 2em; line-height: 2em;"><span style="font-size: 18px;"></span>
              <span style="font-size: 18px;">
                  {{ $t("organization.title1description9") }}
                </span>
            </p>
            <p style="text-indent: 2em; line-height: 2em; text-align: right;"><span style="font-size: 18px;"></span>
              <span style="font-size: 18px;">
                  {{ $t("organization.title1description10") }}
                </span>
            </p>

          </div>
          <span id="vsb_content_2_1002_u16" name="vsb_content_2_1002_u16"></span><br><br>

          <div class="clear"></div>
        </div>

      </div>
    </div>
</template>

<style lang="less">
@cyan: #176998;
.organization {
  .content {
    display: flex;
    justify-content: center;
  }

  .content1 {
    flex-flow: wrap !important;
  }

  .el-card {
    overflow: visible !important;
  }

  .el-card__body {
    position: relative !important;
  }

  .mask {
    display: none;
    text-align: center;
    padding: 10px !important;
    position: absolute;
    background: #bababb;
    z-index: 20;
    // top: 180px;
    // left:0px;
    // margin: 0px auto;
  }

  a {
    text-decoration: none;
    color: #333333;
    -webkit-tap-highlight-color: #333333;
  }
  a:visited {
    color: #333333;
  }
  a:active {
    color: #333333;
  }
  .organizers {
    .type {
      margin: 80px 0 50px 0;
      .el-divider__text {
        font-size: 24px;
      }
    }
    .orgainzer {
      display: block;
      width: 40%;
      margin-bottom: 50px;
      text-align: center;
      .image {
        height: 100px;
        margin: 0 auto;
      }
      .name {
        font-size: 18px;
      }
    }
  }
  .committee {
    .chair {
      width: 70%;
      margin: 50px auto 0 auto;
      .type {
        text-align: center;
        font-size: 24px;
        line-height: 42px;
      }
      .person1 {
        height: 140px;
      }
      .person {
        text-align: center;
        width: 25%;
        font-size: 15px;
        line-height: 12px;
        position: relative;

        .log1 {
          position: absolute;
          width: 5em;
          bottom: -20px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }

  .content > div {
    padding-left: 10px;
    padding-right: 10px;
  }
  .content p {
    margin: 0px;
    text-align: center;
    font-size: 15px;
    line-height: 35px;
  }
}
</style>

<script>
import $ from "jquery";
export default {
  name: "Organization",

  //js
  computed: {
    committee() {
      return this.$t("organization.committee");
    },
  },
  mounted() {
    // $(".log1").mouseover(function() {
    //   $(this).css("background", "#bababb");
    //   var txt = $(this)
    //     .next()
    //     .text();
    //   console.log(txt);
    //   var mask = $(this)
    //     .parent()
    //     .parent()
    //     .find(".mask");
    //   // console.log(mask);
    //   mask.html("<p>" + txt + "</p");
    //   mask.css("display", "block");
    // }),
    // $(".log1").mouseout(function() {
    //   $(this).css("background", "");
    //   $(this)
    //     .parent()
    //     .parent()
    //     .find(".mask")
    //     .css("display", "none");
    // });
  },

  data() {
    return {
      activeNames: ["1", "2", "3", "4"],
    };
  },
};
</script>
